export default __webpack_public_path__ + "static/media/MyMessage.f5cbdd98.svg";